import React from 'react';
export const ArrowRight = () => {
    return (
        <div className="ArrowLeft__solid-white">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293.45 999.99"><path d="M25.23,1000A25.22,25.22,0,0,1,3.39,962.12L219.55,587.56a175.79,175.79,0,0,0-.05-175.33L3.39,37.88A25.24,25.24,0,0,1,47.11,12.64L263.27,387a226.57,226.57,0,0,1,.05,225.82L47.11,987.41A25.21,25.21,0,0,1,25.23,1000Z" transform="translate(0.02 -0.01)"/></svg>
        </div>
    )
}
